import React, { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { supabase } from './supabaseClient';
import iconoApp from './assets/icono.png';
import App from './App';

export default function ParkAccess() {
  const { slug } = useParams();
  const location = useLocation();
  const { techValidated } = location.state || {};
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [proyecto, setProyecto] = useState(null);
  const [acceso, setAcceso] = useState(techValidated || false);
  const [buscando, setBuscando] = useState(true);

  useEffect(() => {
    const buscarParque = async () => {
      const { data: pData, error: pError } = await supabase
        .from('proyectos')
        .select('*')
        .eq('slug', slug)
        .single();
      if (pError || !pData) { setError('Wind farm not found'); setBuscando(false); return; }

      const { data: mData } = await supabase
        .from('maquinas')
        .select('*')
        .eq('proyecto_id', pData.id);

      const maquinasMapeadas = (mData || []).map(m => ({
        ...m,
        tareas: m.tareas || [],
        herramientas: m.herramientas || {},
        componentesExtra: m.componentes_extra || {},
        boltRegister: m.bolt_register || [],
      }));

      setProyecto({
        ...pData,
        nombre_parque: pData.nombre || '',
        maquinas: maquinasMapeadas
      });
      setBuscando(false);
    };
    buscarParque();
  }, [slug]);

  const handlePin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    if (pin === proyecto.pin) {
      setAcceso(true);
    } else {
      setError('Incorrect PIN');
    }
    setLoading(false);
  };

  if (buscando) return (
    <div style={{ minHeight: '100vh', background: '#f4f2ed',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      color: '#c96a10', fontWeight: 700 }}>
      Loading...
    </div>
  );

  if (acceso && proyecto) return (
    <App esTecnico={true} proyectoTech={proyecto} />
  );

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', background: '#f4f2ed' }}>
      <div style={{ background: '#ffffff', border: '1px solid #d4d0c8',
        borderRadius: '12px', padding: '40px', width: '100%', maxWidth: '380px',
        boxShadow: '0 2px 16px rgba(0,0,0,0.08)' }}>
        <div style={{ textAlign: 'center', marginBottom: '28px' }}>
          <img src={iconoApp} alt="logo" style={{ width: '48px', marginBottom: '12px' }} />
          <div style={{ fontSize: '1.4rem', fontWeight: 700, color: '#1a1c1e' }}>
            Wind<span style={{ color: '#c96a10' }}>Manager</span> Pro
          </div>
          {proyecto && (
            <div style={{ marginTop: '12px', padding: '10px 16px',
              background: '#f4f2ed', borderRadius: '8px', border: '1px solid #d4d0c8' }}>
              <div style={{ fontWeight: 700, color: '#1a1c1e', fontSize: '1rem' }}>
                {proyecto.nombre}
              </div>
              <div style={{ color: '#7a7a72', fontSize: '0.8rem', marginTop: '2px' }}>
                {proyecto.modelo_maquina}
              </div>
            </div>
          )}
        </div>

        {error && !proyecto ? (
          <div style={{ textAlign: 'center', color: '#c0392b', fontWeight: 700 }}>
            {error}
          </div>
        ) : (
          <form onSubmit={handlePin}>
            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', color: '#4a4a44', fontSize: '0.75rem',
                fontWeight: 700, marginBottom: '6px', textTransform: 'uppercase' }}>
                PIN
              </label>
              <input
                type="password" value={pin}
                onChange={e => setPin(e.target.value.toUpperCase().slice(0, 6))}
                placeholder="LE4966" maxLength={6}
                autoCapitalize="characters" autoComplete="off"
                style={{ width: '100%', padding: '12px', background: '#f4f2ed',
                  border: '1px solid #bbb8b0', borderRadius: '6px', color: '#1a1c1e',
                  fontSize: '1.3rem', textAlign: 'center', letterSpacing: '0.3em',
                  boxSizing: 'border-box' }}
              />
            </div>
            {error && (
              <div style={{ color: '#c0392b', fontSize: '0.85rem',
                marginBottom: '16px', textAlign: 'center' }}>
                {error}
              </div>
            )}
            <button type="submit" disabled={loading || pin.length !== 6}
              style={{ width: '100%', padding: '12px', background: '#c96a10',
                border: 'none', borderRadius: '6px', color: '#fff',
                fontSize: '0.95rem', fontWeight: 700, cursor: 'pointer',
                opacity: pin.length !== 6 ? 0.5 : 1 }}>
              {loading ? 'Verifying...' : 'Access'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}